import { Avatar, Box, Divider, Flex, SimpleGrid, Text } from "@mantine/core";

import InfoField from "./InfoField";

interface ProfileData {
  workName: string;
  workRole: string;
  workId: string;
  workEmail: string;
  workPhone: string;
  centralPhone: string;
  profileImage?: string;
  personalName: string;
  privatePhone: string;
  privateEmail: string;
  startDate: string;
  birthDate: string;
  location: string;
  contractType: string;
  contactPerson: string;
  languages: string[];
}

interface ProfileHeaderProps {
  data: ProfileData;
}

const ProfileHeader = ({ data }: ProfileHeaderProps) => {
  return (
    <Flex gap="xl" align="flex-start">
      {/* Leva strana - Slika i poslovni podaci */}
      <Flex gap={50} align="flex-start" mr="xl">
        <Avatar size={230} radius="50%" src={data.profileImage} />
        <Box>
          <Text fw={700} fz={28} mb={4}>
            {data.workName}
          </Text>
          <Text c="dark" fz={16} mb="lg">
            {data.workRole} | {data.workId}
          </Text>

          <InfoField label="Email Webkredit.ch" value={data.workEmail} mb="md" />
          <InfoField label="Direktan telefon i WhatsApp" value={data.workPhone} mb="md" />
          <InfoField label="Broj telefona centrale" value={data.centralPhone} />
        </Box>
      </Flex>

      {/* Vertikalna linija */}
      <Divider orientation="vertical" mx="xl" />

      {/* Desna strana - Lični podaci */}
      <Box>
        <Text fw={700} fz={28} mb="lg">
          {data.personalName}
        </Text>

        <SimpleGrid cols={3} spacing="xl" verticalSpacing="lg">
          <InfoField label="Privatni broj telefona" value={data.privatePhone} />
          <InfoField label="Privatni email" value={data.privateEmail} />
          <InfoField label="Datum početka rada" value={data.startDate} />
          <InfoField label="Datum rođenja" value={data.birthDate} />
          <InfoField label="Standort" value={data.location} />
          <InfoField label="Vrsta ugovora" value={data.contractType} />
          <InfoField label="Kontakt osoba" value={data.contactPerson} />
          <InfoField
            label="Jezici agenta"
            value={data.languages.map((lang, index) => (
              <div key={index}>{lang}</div>
            ))}
          />
        </SimpleGrid>
      </Box>
    </Flex>
  );
};

export default ProfileHeader;
